import React, { useState } from 'react';

const THEMES = [
  { name: 'Default (Purple)', accent: '#9d4edd', bg: '#0a0a14', panel: '#12121e' },
  { name: 'Blood Moon (Red)', accent: '#e63946', bg: '#0a0a0a', panel: '#1a1012' },
  { name: 'Arcane (Blue)', accent: '#4895ef', bg: '#0a0e14', panel: '#101820' },
  { name: 'Forest (Green)', accent: '#2d6a4f', bg: '#0a100e', panel: '#0f1a14' },
  { name: 'Gold Dragon', accent: '#e6a817', bg: '#0f0d08', panel: '#1a1608' },
  { name: 'Void (Monochrome)', accent: '#888888', bg: '#080808', panel: '#141414' },
];

export default function DashboardSettings({ onClose, inline }) {
  const [selected, setSelected] = useState(localStorage.getItem('theme') || 'Default (Purple)');

  const applyTheme = (theme) => {
    document.documentElement.style.setProperty('--accent', theme.accent);
    document.documentElement.style.setProperty('--bg', theme.bg);
    document.documentElement.style.setProperty('--panel', theme.panel);
    setSelected(theme.name);
    localStorage.setItem('theme', theme.name);
    localStorage.setItem('themeData', JSON.stringify(theme));
  };

  const body = (
    <>
      <label style={{ fontSize: '0.8rem', color: 'var(--text-dim)', marginBottom: '12px', display: 'block' }}>Color Theme</label>
      <div className="theme-grid">
        {THEMES.map(t => (
          <div key={t.name} className={`theme-swatch${selected === t.name ? ' active' : ''}`} onClick={() => applyTheme(t)}>
            <div className="swatch-preview" style={{ background: t.bg, borderColor: t.accent }}>
              <div className="swatch-accent" style={{ background: t.accent }}></div>
            </div>
            <span className="swatch-name">{t.name}</span>
          </div>
        ))}
      </div>
    </>
  );

  if (inline) return <div className="settings-inline">{body}</div>;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-card" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>🎨 Dashboard Settings</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <div className="modal-body">{body}</div>
        <div className="modal-footer">
          <button className="btn-primary" onClick={onClose}>Done</button>
        </div>
      </div>
    </div>
  );
}
